
define(
	'DC.ItemGroupCustomization.Main'
,   [
		'DC.Facets.Browse.View.Extension',
		'DC.ItemGroup.Details.View.Extension'
	]
,   function (
		DCFacetsBrowseView,
		DCItemGroupDetailsView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container){

			var pageType = container.getComponent('PageType');

			pageType.registerPageType({
				name: 'Item Group Detail View',
				view: DCItemGroupDetailsView,
				routes: ['product/item-group/:id'],
				options: {container: container}
			});

		}
	};
});
